import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../core/authentication/auth.service';

@Component({
  selector: 'app-sign-in-init',
  template: '',
  standalone: false
})
export class SignInInitComponent implements OnInit {
  private authService = inject(AuthService);


  constructor() { }

  ngOnInit(): void {
    this.authService.login();
  }
}
